import http from '../http';
import Qs from 'qs';

// 学校教师考勤确认单列表
const getSchoolSignConfirmListApi = (params) =>
  http
    .post('/theUserIdentity/settlementSheetSch/schoolSignConfirmList', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 学校教师考勤确认单列表
const getSchoolSignConfirmListBySchoolApi = (params) =>
  http
    .post('/school/settlementSheetSch/schoolSignConfirmList', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 教师考勤确认单列表
const getTeachersSignConfirmListApi = (params) =>
  http
    .post(
      '/theUserIdentity/settlementSheetSch/teachersSignConfirmList',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 统计确认单数量
const getStatisticalConfirmationApi = (params) =>
  http
    .post(
      '/theUserIdentity/settlementSheetSch/statisticalConfirmation',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 学校教师考勤确认单操作记录
const getSchoolSettleConfirmationRecordsApi = (params) =>
  http
    .post(
      '/theUserIdentity/settlementSheetSch/schoolSettleConfirmationRecords',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 补发 补扣明细
const getSupplementalRecordsApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/supplementalRecords', { params })
    .then((res) => res.data);
// 取消教师工资单
const setCancelPayrollApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/cancelPayroll', { params })
    .then((res) => res.data);

// 补发 补扣
const setSupplementalApi = (params) =>
  http
    .post('/theUserIdentity/settlementSheetSch/supplemental', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 老师工资单详情
const getTeacherSignConfirmationDetailsApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/teacherSignConfirmationDetails', {
      params
    })
    .then((res) => res.data);

// 运营确认学校工资单
const operationConfirmedApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/operationConfirmed', {
      params
    })
    .then((res) => res.data);
// 撤回工资单确认
const toWithdrawConfirmedApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/toWithdrawConfirmed', {
      params
    })
    .then((res) => res.data);

// 学校确认单详情
const getSchoolSignConfirmDetailsApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/schoolSignConfirmDetails', {
      params
    })
    .then((res) => res.data);
// 确认单审批列表
const getSchoolApprovalPayrollListApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/schoolApprovalPayrollList', {
      params
    })
    .then((res) => res.data);
// 审批失败明细列表
const getSchoolSettleApproveRecordsApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/schoolSettleApproveRecords', {
      params
    })
    .then((res) => res.data);

// 确认单变动列表
const getConfirmSingleChangeListApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/confirmSingleChangeList', {
      params
    })
    .then((res) => res.data);

// 确认变动
const setConfirmSingleChangeApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/confirmSingleChange', {
      params
    })
    .then((res) => res.data);
// 学校确认学校工资单
const setSchoolConfirmedApi = (params) =>
  http
    .get('/school/settlementSheetSch/schoolConfirmed', {
      params
    })
    .then((res) => res.data);
// 查询教师考勤确认财务审批权限
const getFinancialExaminationApprovalAuthorityApi = (params) =>
  http
    .get(
      '/theUserIdentity/settlementSheetSch/financialExaminationApprovalAuthority',
      {
        params
      }
    )
    .then((res) => res.data);
// 财务确认学校工资单
const setFinancialConfirmedApi = (params) =>
  http
    .post('/theUserIdentity/settlementSheetSch/financialConfirmed', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 批量操作 补发 补扣
const setBatchSupplementalApi = (params) =>
  http
    .post('/theUserIdentity/settlementSheetSch/batchSupplemental', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询商户管理员手机号码
const getMerchantsAdministratorInfoApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/merchantsAdministratorInfo', {
      params
    })
    .then((res) => res.data);
// 工资单结算进度
const getSettlementProgressApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/settlementProgress', { params })
    .then((res) => res.data);
// 学校学期收入统计
const getSchoolIncomeStatisticsApi = (params) =>
  http
    .post(
      '/theUserIdentity/settlementSheetSch/schoolIncomeStatistics',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 查询学校教师工资标识列表
const getQuerySchoolTeachersApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/querySchoolTeachers', { params })
    .then((res) => res.data);

// 工资单汇款转账详情
const getRemittanceTransferDetailsApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/remittanceTransferDetails', {
      params
    })
    .then((res) => res.data);
// 添加教师工资
const addSingleArticleTeachersSalariesApi = (params) =>
  http
    .get(
      '/theUserIdentity/settlementSheetSch/addSingleArticleTeachersSalaries',
      { params }
    )
    .then((res) => res.data);
// 给学校财务发送验证短信
const sendMsgApi = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/sendMsg', { params })
    .then((res) => res.data);

// 查询是否已平安进件
const getIsPingAnAccountApi = (params) =>
  http.get('/commons/isPingAnAccount', { params }).then((res) => res.data);

// 费用支出明细-分页
const getPageByConditionApi = (params) =>
  http
    .get('/theUserIdentity/schExpenseTransRecs/pageByCondition', { params })
    .then((res) => res.data);

// 查询转出方
const getOutAccountPageApi = (params) =>
  http
    .get('/theUserIdentity/schExpenseTransRecs/getOutAccountPage', { params })
    .then((res) => res.data);

// 查询转出方信息
const getOutAccountInfoApi = (params) =>
  http
    .get('/theUserIdentity/schExpenseTransRecs/getOutAccountInfo', { params })
    .then((res) => res.data);

// 发短信（转账业务）
const sendTransExpenseMsgApi = (params) =>
  http
    .post('/theUserIdentity/schExpenseTransRecs/sendTransExpenseMsg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 新增费用支出
const setExpenseTransApi = (params) =>
  http
    .post('/theUserIdentity/schExpenseTransRecs/expenseTrans', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询历史转入方
const getInAcctHistoryApi = (params) =>
  http
    .get('/theUserIdentity/schExpenseTransRecs/getInAcctHistory', { params })
    .then((res) => res.data);

// 汇款转账详情
const getExpenseTransDetailApi = (params) =>
  http
    .get('/theUserIdentity/schExpenseTransRecs/getExpenseTransDetail', {
      params
    })
    .then((res) => res.data);
// 金额合计
const getSumAmountApi = (params) =>
  http
    .get('/theUserIdentity/schExpenseTransRecs/sumAmount', {
      params
    })
    .then((res) => res.data);
// 删除教师考勤确认单
const delSheetItem = (params) =>
  http
    .delete('/theUserIdentity/settlementSheetSch/delSheetItem', {
      params
    })
    .then((res) => res.data);
// 删除学校工资单-运营端
const deletePayrollApi = (params) =>
  http
    .delete('/theUserIdentity/settlementSheetSch/deletePayroll', {
      params
    })
    .then((res) => res.data);
// 修改付款证明函
const updateAttachPhotos = (params) =>
  http
    .post('/theUserIdentity/schExpenseTransRecs/updateAttachPhotos', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 账单文件包生成纪录分页
const getSettlementFileDownloadRecListApi = (params) =>
  http
    .get('/theUserIdentity/SettlementFileDownloadRec/page', {
      params
    })
    .then((res) => res.data);

// 账单文件包生成纪录 删除
const delSettlementFileDownloadRecListApi = (params) =>
  http
    .delete('/theUserIdentity/SettlementFileDownloadRec/delete', {
      params
    })
    .then((res) => res.data);

// 账单文件包生成
const createSettlementFileDownloadRecApi = (params) =>
  http
    .post('/theUserIdentity/SettlementFileDownloadRec/add', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

export default {
  deletePayrollApi,
  getSchoolSignConfirmListApi,
  getSchoolSignConfirmListBySchoolApi,
  getTeachersSignConfirmListApi,
  getStatisticalConfirmationApi,
  getSchoolSettleConfirmationRecordsApi,
  getSupplementalRecordsApi,
  setCancelPayrollApi,
  setSupplementalApi,
  getTeacherSignConfirmationDetailsApi,
  operationConfirmedApi,
  toWithdrawConfirmedApi,
  getSchoolSignConfirmDetailsApi,
  getSchoolApprovalPayrollListApi,
  getSchoolSettleApproveRecordsApi,
  getConfirmSingleChangeListApi,
  setConfirmSingleChangeApi,
  setSchoolConfirmedApi,
  getFinancialExaminationApprovalAuthorityApi,
  setFinancialConfirmedApi,
  setBatchSupplementalApi,
  getMerchantsAdministratorInfoApi,
  getSettlementProgressApi,
  getSchoolIncomeStatisticsApi,
  getQuerySchoolTeachersApi,
  getRemittanceTransferDetailsApi,
  addSingleArticleTeachersSalariesApi,
  sendMsgApi,
  getIsPingAnAccountApi,
  getPageByConditionApi,
  getOutAccountPageApi,
  getOutAccountInfoApi,
  sendTransExpenseMsgApi,
  setExpenseTransApi,
  getInAcctHistoryApi,
  getExpenseTransDetailApi,
  getSumAmountApi,
  delSheetItem,
  updateAttachPhotos,
  getSettlementFileDownloadRecListApi,
  createSettlementFileDownloadRecApi,
  delSettlementFileDownloadRecListApi
};
